export default "__VITE_ASSET__D1z19qoi__"